export default {
    manage_createEditEquipment_EditTitle: "Editar Equipamiento",
    manage_createEditEquipment_CreateTitle: "Crear nuevo Equipamiento",
    manage_createEditEquipment_success: "Equipamiento fue creado exitosamente",
    manage_createEditEquipment_success_edit: "Equipamiento fue actualizado exitosamente",
    manage_createEditEquipment_duplicatedEquipmentErrorMessage: "Este Equipamiento ya existe",
    manage_createEditEquipment_NameInputLabel: "Nombre de Equipamiento"
}